(function (ng) {
    //service that retrieves the product page html
    //binds to ~/packages/view-product endpoint
    ng.module('evo.Packages.Services').factory('productPageService', ['$http', 'PACKAGES_SERVICE_BASE',
        function ($http, PACKAGES_SERVICE_BASE) {
            return {
                getProductPage: function (productPageId) {
                    var url = PACKAGES_SERVICE_BASE + 'view-product/' + productPageId;
                    return $http.get(url).then(function (response) { return response.data; });
                }
            };
        }
    ]);
})(angular);